<template>
  <hm-sync>
    <div class>
      <div class="table-panel flex flex-between">
        <el-button type="primary" size="small" @click="addCategory"
          >新增分类</el-button
        >
        <div>
          <el-input
            clearable
            v-model.trim="keyWords"
            placeholder="输入分类名称"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <el-table
        @sort-change="sortChange"
        :data="microShopGoodsCategoryList.records"
        style="width: 100%"
        stripe
        size="small"
        border
        lazy
        row-key="wxshopCategoryId"
        :load="load"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          label="分类名称"
          width="180"
          prop="categoryName"
        ></el-table-column>
          <el-table-column
          header-align="center"
          label="是否显示分类"
          width="180"
          align="center"
          prop="isFrontShow"
        >
        <template slot-scope="scope">
          <div :class="scope.row.isFrontShow==='yes'?'success':'gray'">
          {{scope.row.isFrontShow==="yes"?"显示":"隐藏"}}

          </div>
        </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="排序"
          width="180"
          sortable
          prop="seqNum"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryLogo"
          label="分类图标"
          width="180"
        >
          <template slot-scope="scope">
            <img style="width: 40px" :src="scope.row.categoryLogo" alt />
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryLevel"
          label="级别"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="notRecycleSpuNum"
          sortable
          label="微店商品数量"
        >
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="moveTo(scope.row)"
            >{{scope.row.notRecycleSpuNum}}</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="recycleSpuNum"
            sortable
            label="回收站商品数量"
        >
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="moveToRecycle(scope.row)"
            >{{scope.row.recycleSpuNum}}</el-button
            >
          </template>
        </el-table-column>
       <!-- <el-table-column header-align="center" align="center" label="设置">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="moveTo(scope.row)"
            >查看商品</el-button
            >
          </template>
        </el-table-column>-->
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="添加子分类" placement="top">
                <div class="pointer mr10" @click="addChild(scope.row)">
                  <span class="hmicon icon-tianjiaxiaji blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="编辑" placement="top">
                <div class="pointer mr10" @click="edit(scope.row)">
                  <span class="hmicon icon-bianji blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="删除" placement="top">
                <div
                  class="pointer"
                  @click="remove(scope.row)"
                  v-if="!scope.row.isChild && scope.row.relationSpu === 0"
                >
                  <span class="hmicon icon-shanchu primary"></span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="microShopGoodsCategoryList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogVisible"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="分类层级">
          <el-radio-group
            v-model="ruleForm.level"
            :disabled="mode === 'addChild'"
            @change="switchLevel"
          >
            <el-radio label="parent">一级分类</el-radio>
            <el-radio label="child">子分类</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分类名称" prop="categoryName">
          <el-input
            v-model="ruleForm.categoryName"
            maxlength="20"
            size="small"
            placeholder="请输入单行文本，限制20个字符"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否显示分类" prop="isFrontShow">
           <el-switch
            v-model="ruleForm.isFrontShow"
            active-text="显示"
            inactive-text="隐藏"
            active-value="yes"
            inactive-value="no"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="排序">
          <el-input
            v-model="ruleForm.seqNum"
            size="small"
            @input="filterGt0OrFixed"
            placeholder="请输入整数"
          ></el-input>
        </el-form-item>
        <el-form-item label="上级分类" v-if="ruleForm.level === 'child'">
          <el-cascader
            v-if="mode !== 'addChild'"
            ref="cascader"
            v-model="ruleForm.wxshopCategoryId"
            :disabled="ruleForm.level === 'parent'"
            :props="props"
            :show-all-levels="false"
            size="small"
          ></el-cascader>
          <el-input
            v-if="mode === 'addChild'"
            :value="currentRow.categoryName"
            size="small"
            type="text"
            disabled
          />
        </el-form-item>
        <el-form-item label="分类图标">
          <div class="flex">
            <div class="flex flex-center item-center  upload-upload-btn">
              <div
                class="flex flex-column flex-center open-file"
                @click="hmUploadVisible = true"
                v-if="!ruleForm.categoryLogo"
              >
                <div class="add-wrapper">
                  <span class="hmicon icon-hao pointer"></span>
                </div>
                <span>添加图片</span>
              </div>
              <div v-if="ruleForm.categoryLogo" class="mr10 flex item-end">
                <div class="close-wrapper" @click="ruleForm.categoryLogo = ''">
                  <span class="hmicon icon-jujue"></span>
                </div>
                <img
                  class="logo"
                  @click="hmUploadVisible = true"
                  :src="ruleForm.categoryLogo"
                  alt="logo"
                />
              </div>
            </div>
            <div class="flex flex-column flex-end">
              <div class="tips">只能上传jpg/png文件，且不能超过1MB</div>
              <div class="tips">
                建议二级分类图片尺寸为508*108px,三级分类图片尺寸为400x400px(最多上传一张）
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <!-- <my-upload
        field="file"
        @crop-upload-success="cropUploadSuccess"
        v-model="show"
        noCircle
        noSquare
        :width="400"
        :height="400"
        :headers="{ 'X-Access-Token': $token }"
        :params="{ fileDir: 'goodsCenter' }"
        :url="$uploadUrl"
        img-format="png"
      ></my-upload>-->
      <div class="btn-wrapper flex flex-center">
        <el-button
          size="small"
          type="primary"
          @click="save"
          :disabled="
            !ruleForm.wxshopCategoryId.length && ruleForm.level === 'child'
          "
          >确 定</el-button
        >
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <hm-upload
      :hmUploadVisible="hmUploadVisible"
      fileDir="decoration"
      @cancleUpload="hmUploadVisible = false"
      @hmUploadSuccess="hmUploadSuccess"
    ></hm-upload>
  </hm-sync>
</template>

<script>
import HmSync from "@/components/HmIsSync";
// import myUpload from "vue-image-crop-upload";
import HmUpload from "@/components/HmUpload";
import { setCookie, getCookie } from "@/utils/utils";
import { mapGetters } from "vuex";
export default {
  components: {
    HmSync,
    HmUpload
    // myUpload
  },
  data() {
    return {
      hmUploadVisible: false,
      ruleForm: {
        isFrontShow: "yes",
        wxshopCategoryId: [],
        level: "parent",
        categoryLogo: "",
        categoryName: "",
        seqNum: ""
      },
      rules: {
        categoryName: {
          required: true,
          trrger: "blur",
          message: "请输入分类名"
        },
        isFrontShow: {
          required: true,
          trrger: "blur",
          message: "请选择"
        }
      },
      show: false,
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: 1,
                curCategoryId: this.currentRow.wxshopCategoryId
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.wxshopCategoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: level + 1,
                wxshopParentCategoryId: data.wxshopCategoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.wxshopCategoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      title: "",
      mode: "add",
      keyWords: "",
      sort: {},
      level: 0,
      wxshopParentCategoryId: "",
      parentCategoryName: "",
      dialogVisible: false,
      categoryName: "",
      currentRow: {},
      tableData1: [],
      currentPage: 1,
      pageSize: 10
    };
  },
  computed: mapGetters(["microShopGoodsCategoryList"]),
  watch: {
    "microShopGoodsCategoryList.total": {
      handler(val) {
        if (
          val == (this.currentPage - 1) * this.pageSize &&
          this.pageTotal != 0
        ) {
          this.currentPage -= 1;
          this.queryList();
        }
      },
      deep: true
    }
  },
  created() {},
  mounted() {
    this.getParamsCookie();
    this.queryList();
  },
  methods: {
    filterGt0OrFixed() {
      this.ruleForm.seqNum = this.ruleForm.seqNum.replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm.seqNum = this.ruleForm.seqNum.replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm.seqNum = this.ruleForm.seqNum.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm.seqNum = this.ruleForm.seqNum
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm.seqNum = this.ruleForm.seqNum.replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      this.ruleForm.seqNum = this.ruleForm.seqNum.replace(/\./g, "");
      if (this.ruleForm.seqNum.indexOf(".") < 0 && this.ruleForm.seqNum != "") {
        //首位是0的话去掉
        this.ruleForm.seqNum = parseFloat(this.ruleForm.seqNum);
      }
    },
    sortChange(sort) {
      this.currentPage = 1;
      this.pageSize = 10;
      this.sort = sort;
      this.queryList();
    },
    moveTo(row) {
      this.$router.push({
        name: "MicroShopGoodsList",
        query: {
          wxshopCategoryId: row.wxshopCategoryId
        }
      });
    },
    moveToRecycle(row) {
      this.$router.push({
        name: "RecycleBin",
        query: {
          wxshopCategoryId: row.wxshopCategoryId
        }
      });
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    switchLevel() {
      this.ruleForm.wxshopCategoryId = [];
    },
    queryList() {
      this.setParamsCookie();
      this.$store.dispatch("queryMicroShopGoodsCategoryListNew", {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        keyWords: this.keyWords,
        order: this.sort.order,
        prop: this.sort.prop
      });
    },
    setParamsCookie() {
      let searchCondition = {
        keyWords: this.keyWords,
        order: this.sort.order,
        prop: this.sort.prop
      };
      setCookie({
        key: "microShopGoodsCateParams",
        type: "session",
        data: Object.assign({}, searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({
        key: "microShopGoodsCateParams",
        type: "session"
      });
      if (prams) {
        this.keyWords = prams.keyWords;
        this.sort.order = prams.order;
        this.sort.prop = prams.prop;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    // cropUploadSuccess(jsonData) {
    //   this.ruleForm.categoryLogo = jsonData.result;
    // },
    hmUploadSuccess(url) {
      this.ruleForm.categoryLogo = url;
      this.hmUploadVisible = false;
    },
    addCategory() {
      this.mode = "add";
      this.title = "新增分类";
      this.dialogVisible = true;
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
    },
    addChild(row) {
      this.mode = "addChild";
      this.title = "新增子分类";
      this.currentRow = row;
      this.dialogVisible = true;
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
      this.ruleForm.level = "child";
      this.ruleForm.wxshopCategoryId = [this.currentRow.wxshopCategoryId];
      this.level = +this.currentRow.categoryLevel + 1;
    },
    edit(row) {
      this.mode = "edit";
      this.title = "编辑分类";
      this.currentRow = row;
      this.dialogVisible = true;
      this.$store
        .dispatch("queryMicroShopGoodsCategoryDetails", {
          wxshopCategoryId: this.currentRow.wxshopCategoryId
        })
        .then(res => {
          this.ruleForm.level =
            +this.currentRow.categoryLevel > 1 ? "child" : "parent";
          this.ruleForm.categoryName = this.currentRow.categoryName;
          this.ruleForm.categoryLogo = this.currentRow.categoryLogo;
          this.ruleForm.wxshopCategoryId = [res.result.wxshopParentCategoryId];
          this.ruleForm.seqNum = this.currentRow.seqNum;
          this.ruleForm.seqNum = this.currentRow.seqNum;
          this.ruleForm.isFrontShow = res.result.isFrontShow;
          setTimeout(() => {
            if (this.$refs.cascader) {
              this.$refs.cascader.inputValue = this.parentCategoryName;
            }
          }, 0);
        });
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
      this.parentCategoryName = "";
      this.ruleForm.categoryLogo = "";
      this.ruleForm.seqNum = "";
    },
    remove(row) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("deleteMicroShopGoodsCategory", {
            wxshopCategoryId: row.wxshopCategoryId
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.$store.commit("QUERY_MICRO_SHOP_GOOD_CATEGORY_LIST", {
                result: { record: [] }
              });
              this.queryList();
            }
          });
      });
    },
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          // const categoryLevel =
          //   this.ruleForm.level === "parent" ? "1" : this.level;
          const wxshopParentCategoryId =
            this.ruleForm.level === "parent"
              ? ""
              : this.ruleForm.wxshopCategoryId[
                  this.ruleForm.wxshopCategoryId.length - 1
                ];
          let params = {
            // categoryLevel,
            isFrontShow: this.ruleForm.isFrontShow,
            categoryLogo: this.ruleForm.categoryLogo,
            categoryName: this.ruleForm.categoryName,
            seqNum: this.ruleForm.seqNum,
            wxshopParentCategoryId
          };
          let actionName = "";
          if (this.mode === "add" || this.mode === "addChild") {
            actionName = "addMicroShopGoodsCategory";
          } else if (this.mode === "edit") {
            params = Object.assign(params, {
              wxshopCategoryId: this.currentRow.wxshopCategoryId
            });
            actionName = "editMicroShopGoodsCategory";
          }

          this.$store.dispatch(actionName, params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.dialogVisible = false;

              this.$store.commit("QUERY_MICRO_SHOP_GOOD_CATEGORY_LIST", {
                result: { record: [] }
              });
              this.queryList();
            }
          });
        } else {
          return false;
        }
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    load(tree, treeNode, resolve) {
      const { categoryLevel, wxshopCategoryId } = tree;
      resolve([]);
      this.$store
        .dispatch("queryMicroShopGoodsCategoryListByParentNew", {
          wxshopParentCategoryId: wxshopCategoryId,
          categoryLevel: +categoryLevel + 1,
          pageNo: 1,
          pageSize: 999
        })
        .then(res => {
          if (res.code === "0" && res.result.records.length) {
            res.result.records.forEach(v => {
              v.hasChildren = Boolean(v.isChild);
            });
            resolve(res.result.records);
          } else {
            resolve([]);
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tips {
  color: #999;
  font-size: 12px;
  line-height: 20px;
}
.upload-upload-btn {
  position: relative;
  border: 1px solid #ddd;
  text-align: center;
  box-sizing: border-box;
  padding: 10px;
  margin-right: 10px;
  width: 120px;
  height: 120px;
  cursor: pointer;

  .close-wrapper {
    position: absolute;
    top: -20px;
    right: -10px;
    z-index: 100;
    .hmicon {
      font-size: 20px;
    }
  }

  .add-wrapper {
    width: 30px;
    height: 30px;
    line-height: 30px;
    background: #e50065;
    color: #fff;
    text-align: center;
    border-radius: 50%;
    margin: 0 auto;
    span {
      font-size: 12px;
    }
    cursor: pointer;
    .hmicon {
      font-size: 14px;
    }
  }
}
.logo {
  width: 80px;
}
</style>
